import API from '@util/ApiUtil';

export default class TranslationApi {
  public static getTranslations = (lang: string): any => {
    return API.get(`/translations/${lang}`);
  };
}
